import { useMemo } from 'react';

import type { GridInitialState } from '@mui/x-data-grid';

import { buildAscendingSorting } from '../../../components/DataGrid/utils/build-ascending-sorting.util';
import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import { STATUS_ID } from '../constants/data-grid.constant';

export const useInitialGridState = () => {
  const { genericStatusesCodeMap } = useReferencesContext();

  const initialGridState = useMemo<GridInitialState>(
    () => ({
      sorting: buildAscendingSorting('code'),
      columns: {
        columnVisibilityModel: {
          [STATUS_ID]: false,
        },
      },
      filter: {
        filterModel: {
          items: [
            {
              field: STATUS_ID,
              operator: 'is',
              value: genericStatusesCodeMap.Enabled.code,
            },
          ],
        },
      },
    }),
    [genericStatusesCodeMap.Enabled.code],
  );

  return { initialGridState };
};
